<template>
    <div class="employers">
        <stb-main>
            <div id="map" ref="map"></div>
            <!--
            <stb-notifications slot="sidebar" :title="$t('employers')" :items="employerList"></stb-notifications>
            -->
            <stb-notifications
                slot="sidebar"
                :title="$t('employers')"
                :items="items"
                @item-click="item_click"
            ></stb-notifications>
        </stb-main>
        
    </div>
</template>

<style lang="scss">
    .employers .main {
        padding-bottom: 0em !important; 
    }
</style>

<script>
import {
    create_map,
    update_markers,
} from '@/utils/map'

import _ from 'lodash'

export default {
    static() {
        return {
            map: null,
            markers: {},
            api_module: null,
        };
    },
    data() {
        return {
            type: null,
            query: null,
            results: [],
            title: '',
            employerList: [
                    {
                        title: 'Steuerberater X',
                        subtitle: "steuerbuero@mv.de",
                        meta: 'August-Bebel-Str. 32c, Rostock',
                        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et',
                        icon: "avatar"
                    },
                    {
                        title: 'Steuerberater Y',
                        subtitle: "steuerbuero@mv.de",
                        meta: 'August-Bebel-Str. 32c, Rostock',
                        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et',
                        icon: "avatar"
                    },
                    {
                        title: 'Steuerberater Z',
                        subtitle: "steuerbuero@mv.de",
                        meta: 'August-Bebel-Str. 32c, Rostock',
                        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et',
                        icon: "avatar"
                    },
                ],
        };
    },
    mounted() {
        this.$shared.sync(this, 'query');

        this.update_type();
        this.create_map();
    },
    watch: {
        query: _.debounce(function(val) {
            this.update_results();
        }, 450),
        results() {
            update_markers(this.map, this.markers, this.results, (marker, id) => {
                marker.addListener('click', () => {
                    this.$router.push('/' + this.type + '/' + id);
                });
            });
            /*
            (marker, id) => {
                // https://developers.google.com/maps/documentation/javascript/examples/event-simple
                marker.addListener('click', () => {
                    console.log('you\'ve clicked me');
                });
            }
            */
        },
        '$route'(from, to) {
            if (!to.query.type || (from.query.type != to.query.type)) {
                this.update_type();
            }
        },
    },
    computed: {
        items() {
            return this.results.map((item) => {
                return {
                    objectId: item.objectId,
                    title: item.name,
                    subtitle: item.mail,
                };
            });
        },
    },
    methods: {
        create_map() {
            // create map
            var element = this.$refs.map;
            //document.getElementById('map');
            this.map = create_map(element);
        },
        update_results() {

            let loader = this.$loading.show();
            if (this.query) {
                var query = this.api_module.query();
                //query.fullText('name', this.query);
                query.startsWith('name', this.query);
                this.api_module.load(query).then((results) => {
                    this.results = results;
                    loader.hide();
                });
            } else {
                this.api_module.load().then((results) => {
                    this.results = results;
                    loader.hide();
                });
            }
        },
        update_type() {
            /**
             * dynamically get type of search
             **/
            var type = this.$route.query.type,
                type_options = ['employers', 'applicants'];
            if (type_options.indexOf(type) === -1) {
                type = type_options[0];
            }
            if (type == 'applicants') {
                this.api_module = this.$api.applicants;
                this.title = this.$t('applicants');
            } else {
                this.api_module = this.$api.employers;
                this.title = this.$t('employers');
            }
            this.type = type;
            // reset query
            this.query = '';

            this.update_results();
        },
        item_click(item) {
            console.log('item_click')
            var id = item.objectId;
            this.$router.push('/' + this.type + '/' + id);
            /*
            // focus on marker
            var marker = this.markers[id];
            if (marker) {
                this.map.panTo(marker.getPosition());
            }
            */
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/pages/employers.vue